<template>
    <pc-news v-if="isPc()"> </pc-news>
    <mobile-news v-else></mobile-news>
</template>
<script>
import PcNews from './PcNews.vue'
import MobileNews from './MobileNews.vue'
export default{
    components:{ PcNews, MobileNews },
    methods: {
        isPc(){
            return screen.width > 800 ? true: false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// News.vue?25244e55